export const GetQuoteData = {
  heroData: {
    title: "Get ",
    title2: "Quote",
    subTitle: "Share your requirement and our experts will contact you",
    imgUrl:
      "https://proresglovebox.com/wp-content/uploads/2025/02/IISc-MRC-Customised.jpg",
  },

 formData: {
    leftSection: {
      imgUrl:
        "https://proresglovebox.com/wp-content/uploads/2025/02/IISc-MRC-Customised.jpg",

      title: "Let’s Discuss Your Requirement",
      titleAlt: "Engineered Solutions. Reliable Support.",

      description:
        "Connect with our technical team for glovebox systems, custom engineering, accessories, or service support.",

      iconUrl:
        "https://cdn-icons-png.flaticon.com/512/545/545682.png",

      address:
        "ProRes Scientific Pvt. Ltd.,No. 362/5, Site No.5, Santhosh Layout, Kadabgere Cross, Bengaluru, Karnataka, India",

      mobileNUmber:
        "+91 98446 06132",

      emailAddress:
        "js@proresscientific.in",
    },
  },
  formConfig: {
    title: "Get a Customized Quote",
    description:
      "Please provide accurate information to help us understand your requirements and respond quickly.",
    fields: [
      { name: "name", label: "Full Name", type: "text", required: true },
      { name: "company", label: "Company / Institution", type: "text", required: true },
      { name: "email", label: "Email Address", type: "email", required: true },
      { name: "mobile", label: "Mobile Number", type: "tel", required: true },
      {
        name: "product",
        label: "Product / System",
        type: "select",
        options: [
          "Pro-Lab GB II",
          "Pro-Lab GB III",
          "Pro-Lab GB IV",
          "Custom Glovebox System",
          "Service & Maintenance",
        ],
        required: true,
      },
      {
        name: "application",
        label: "Application / Industry",
        type: "select",
        options: [
          "Research & Development",
          "Battery & Energy Materials",
          "Pharmaceutical",
          "Chemical Processing",
          "Nuclear / Atomic Research",
          "Other",
        ],
        required: true,
      },
      {
        name: "message",
        label: "Requirement Details",
        type: "textarea",
        required: true,
      },
    ],
    submitText: "Request Quote",
    disclaimer:
      "By submitting this form, you agree to be contacted by ProRes Scientific regarding your inquiry.",
  },
};
